import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { Curve } from '../Curve';
import { Grid, GridArea } from '../Grid';
import { useMedia } from '../../hooks/useMedia';
import { media, theme } from '../themes/theme';
import { ColorContextProvider } from '../../src/providers/ColorContext';
const StageSection = styled.section `
  position: relative;
  background-color: ${({ backgroundColor }) => backgroundColor};
  overflow: hidden;
`;
const StageInnerSection = styled.div `
  display: flex;
  justify-content: ${props => (props.isBigStage ? 'center' : 'flex-start')};
  z-index: 1;
  padding-top: 2.5rem;
  margin-bottom: 2rem;

  ${media.mobileXL `
    ${props => props.isBigStage &&
    css `
        padding-top: 6.5rem;
      `}
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  `};

  @media (min-width: 76rem) {
    padding-top: ${props => (props.isBigStage ? '6.5rem' : '5.25rem')};
  }
`;
const StageInnerContainer = styled.div `
  width: 100%;
  max-width: 75rem;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  position: relative;
`;
const StageImage = styled.img `
  transition: transform 0.9s, opacity 0.9s;
  transition-delay: 0.5s;
  transform: translate3d(0, 10rem, 0);
  opacity: 0;
  visibility: hidden;
  max-width: 100%;

  ${media.mobileXL `
    margin-top: ${({ isBigStage }) => (!isBigStage ? '10.5rem' : '5rem')};
    width: auto;
    max-height: ${({ isBigStage }) => (isBigStage ? '44.375rem' : '31.875rem')};
    max-width: revert;
  `}

  ${media.laptop `
    margin-top: ${({ isBigStage }) => (!isBigStage ? 0 : '3rem')};;
  `}

  ${props => props.isImageLoaded &&
    css `
      opacity: 1;
      visibility: visible;
      transform: translate3d(0, 0, 0);
    `};
`;
const StyledImageWrapper = styled.div `
  line-height: 0;

  ${media.mobileXL `
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    /* Design specification, width of Macbook 15" */
    max-width: 1680px;
    min-height: 28rem;
    margin-left: auto;
    margin-right: auto;
  `}
`;
export function Stage({ backgroundColor = 'transparent', imageDesktop, imageMobile, imageDescription = '', isBigStage = false, curveColor = 'transparent', curveLayout = undefined, className, children, }) {
    const image = useRef(null);
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const onImageLoad = () => setIsImageLoaded(true);
    const isLaptop = useMedia({ minWidth: theme.screenLaptop });
    useEffect(() => {
        if (image.current !== null && image.current.complete)
            setIsImageLoaded(true);
    }, []);
    return (React.createElement(ColorContextProvider, { backgroundColor: backgroundColor },
        React.createElement(StageSection, { backgroundColor: backgroundColor, isBigStage: isBigStage, className: className },
            React.createElement(StageInnerSection, { isBigStage: isBigStage },
                React.createElement(StageInnerContainer, null,
                    React.createElement(Grid, { hasGapH: true },
                        React.createElement(GridArea, { colStart: 0, colWidth: !isLaptop ? 12 : 6 }, children)))),
            React.createElement(StyledImageWrapper, null,
                React.createElement("picture", null,
                    React.createElement("source", { media: "(max-width: 37.9375rem)", srcSet: imageMobile }),
                    React.createElement("source", { media: "(min-width: 38rem)", srcSet: imageDesktop }),
                    React.createElement(StageImage, { isBigStage: isBigStage, ref: image, src: imageMobile, isImageLoaded: isImageLoaded, onLoad: onImageLoad, alt: imageDescription }))),
            curveColor !== 'transparent' && curveLayout && (React.createElement(Curve, { layout: curveLayout, color: curveColor, isInverted: true })))));
}
